// extracted by mini-css-extract-plugin
module.exports = {"lossPropertyContainer":"LossPropertyIncidentDetails_lossPropertyContainer__2Mzxe"};